import { render, staticRenderFns } from "./bimSelect.vue?vue&type=template&id=d87d93f8&scoped=true&lang=html&"
import script from "./bimSelect.vue?vue&type=script&lang=js&"
export * from "./bimSelect.vue?vue&type=script&lang=js&"
import style0 from "./bimSelect.vue?vue&type=style&index=0&id=d87d93f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d93f8",
  null
  
)

export default component.exports